export enum TabType {
    TOPUP = "Balance Settings",
    ESIM_DETAILS = "eSIM Details",
    ESIM_TOPUP = "Top Up eSIM",
    GENERATE = "Generate eSIM"
}
